module.exports = __webpack_public_path__ + "static/media/36.ba414a40.png";